import { lazy } from "react";

export const Sidebar = lazy(()=>import("../components/Sidebar"))
export const Topbar = lazy(()=>import("../components/Topbar"))
export const Home = lazy(()=>import("../components/Home"))
export const MyOrders = lazy(()=>import("../components/MyOrders"))
export const Services = lazy(()=>import("../components/Services"))
export const StyleGuide = lazy(()=>import("../components/StyleGuide"))
export const MyVideos = lazy(()=>import("../components/MyVideos"))
export const Coupons = lazy(()=>import("../components/Coupons"))
export const MyProfile = lazy(()=>import("../components/MyProfile"))
export const Referral = lazy(()=>import("../components/Referral"))
export const MyTeam = lazy(()=>import("../components/MyTeam"))
export const Support = lazy(()=>import("../components/Support"))
export const AiMarketingHub = lazy(()=>import("../components/AiMarketingHub"))
export const PropertyDescription = lazy(()=>import("../components/AiMarketingHub/PropertyDescription"))
export const EmailGeneration = lazy(()=>import("../components/AiMarketingHub/EmailGeneration"))
export const RewriteParagraph = lazy(()=>import("../components/AiMarketingHub/RewriteParagraph"))
export const SocialMediaCaption = lazy(()=>import("../components/AiMarketingHub/SocialMediaCaption"))
export const AgentsBio = lazy(()=>import("../components/AiMarketingHub/AgentsBio"))
export const History = lazy(()=>import("../components/AiMarketingHub/History"))
export const Flyer = lazy(()=>import("../components/Flyer/Flyer"))
export const Success = lazy(()=>import("../components/Form/Success"))
export const ServiceCheckout = lazy(()=>import("../components/ServiceCheckout"))
export const NotFound = lazy(()=>import("../components/NotFound"))


// function wait(time){
//     return new Promise(resolve=>{
//         setTimeout(resolve, time);
//     })
// }